import { wbFetch } from "./wbFetch"

export type WbCharacteristic = {
  "charcID": number,
  "subjectName": string,
  "subjectID": number,
  "name": string,
  "required": boolean,
  "unitName": string,
  "maxCount": number,
  "popular": false,
  "charcType": 1
}

export const getGoodCharacteristics = async (subjectId: number): Promise<WbCharacteristic[]> => {
  const response = await wbFetch(`https://content-api.wildberries.ru/content/v2/object/charcs/${subjectId}`, "GET")

  return response.data || [];
}
